export default __webpack_public_path__ + "static/media/production ID_4651946.25720e4e.mp4";